module.exports = __webpack_public_path__ + "static/media/bg14.33c133f3.jpg";